/**
 * Suspicious v2 (founder 2026-10-18) — one icon shape for every
 * severity. Colour = severity (coral / amber / sky / muted), shape =
 * ShieldAlert everywhere. Tooltip spells out what the word means in
 * plain English so a merchant doesn't have to guess what "critical"
 * covers.
 */

import { ShieldAlert } from 'lucide-react';
import type { ReactNode } from 'react';

import type { ThemeTokens } from '@sill/ui/tokens';
import type { ThreatSenderSummary } from '@sill/types/api';

export type Severity = ThreatSenderSummary['max_severity'];

export interface SeverityVisual {
  readonly node: ReactNode;
  readonly colour: string;
  readonly tip: string;
}

export const SEVERITY_TIP: Record<Severity, string> = {
  critical: 'Critical — tried to run code or steal credentials. Check any request marked 200.',
  high: 'High — probing for secret files or known weaknesses.',
  medium: 'Medium — attack-shaped requests, usually automated.',
  low: 'Low — unusual scanning, usually harmless.',
};

export function severityIcon(sev: Severity, C: ThemeTokens, size = 14): SeverityVisual {
  const colour = sev === 'critical' ? C.coralFg
    : sev === 'high' ? C.amberFg
      : sev === 'medium' ? C.skyFg
        : C.muted;
  const tip = `${SEVERITY_TIP[sev]} Severity is what they tried, not whether it worked.`;
  return {
    node: <ShieldAlert size={size} color={colour} />,
    colour,
    tip,
  };
}
